import Icon from '../components/Icon.vue'

Icon.register({"thermometer-three-quarters":{"width":256,"height":512,"paths":[{"d":"M192 384C192 419.3 163.3 448 128 448 92.7 448 64 419.3 64 384 64 360.3 76.9 339.7 96 328.6V160C96 142.3 110.3 128 128 128S160 142.3 160 160V328.6C179.1 339.7 192 360.3 192 384zM224 299.3C243.9 321.9 256 351.5 256 384 256 454.7 198.7 512 128 512 127.7 512 127.4 512 127.1 512 56.8 511.5-0.4 453.6 0 383.3 0.2 351.1 12.2 321.8 32 299.3V96C32 43 75 0 128 0S224 43 224 96V299.3zM208 384C208 349.7 188.6 331.8 176 317.5V96C176 69.5 154.5 48 128 48S80 69.5 80 96V317.5C67.3 331.9 48.2 349.6 48 383.6 47.8 427.5 83.6 463.7 127.4 464L128 464C172.1 464 208 428.1 208 384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/thermometer-three-quarters.js
// module id = null
// module chunks = 